export var IMAGE_API_FAILURE = "assets/account-card-mfe/api_failure.png";
export var IMAGE_ACCOUNT_CARD_LOGO = "assets/account-card-mfe/logo.svg";
export var IMAGE_SYNCHRONY_LOGO = "assets/synchrony/logo.svg";
export var IMAGE_AUTOPAY_ICON = "assets/account-card-mfe/AutopayIcon.svg";
//# sourceMappingURL=assets.js.map